export const gridDebug = (() => {
	const makeGrid = () => {
		let grid_ctn = document.createElement("div");
		grid_ctn.setAttribute("id", "grid-debug");
		grid_ctn.className = "grid-debug";

		let grid_wrapper = document.createElement("div");
		grid_wrapper.className = "container";

		let grid_row = document.createElement("div");
		grid_row.className = "row";

		let grid_items = [];

		for (let i = 0; i < 12; i++) {
			let item = document.createElement("div");
			item.className = "col-1";

			let item_content = document.createElement("div");

			item.appendChild(item_content);

			grid_items.push(item);
		}

		grid_items.forEach((item) => grid_row.appendChild(item));
		grid_wrapper.appendChild(grid_row);
		grid_ctn.appendChild(grid_wrapper);

		document.body.insertAdjacentElement("beforeend", grid_ctn);
	};

	const createDebugSwitch = () => {
		let toggle_debug_ctn = document.createElement("div");
		toggle_debug_ctn.className = "debug-toggle";

		let checkbox_label = document.createElement("label");
		checkbox_label.setAttribute("for", "toggle_debug");
		checkbox_label.setAttribute("title", "Show grid");

		let checkbox = document.createElement("input");
		checkbox.setAttribute("type", "checkbox");
		checkbox.setAttribute("id", "toggle_debug");

		toggle_debug_ctn.appendChild(checkbox);
		toggle_debug_ctn.appendChild(checkbox_label);

		document.body.insertAdjacentElement("beforeend", toggle_debug_ctn);
	};

	const init = () => {
		createDebugSwitch();

		let checkbox = document.getElementById("toggle_debug");

		// Restaurer l'état du checkbox depuis le localStorage
		let gridVisible = localStorage.getItem("gridVisible") === "true";
		checkbox.checked = gridVisible;

		if (gridVisible) {
			makeGrid();
		}

		checkbox.addEventListener("change", (e) => {
			let isChecked = e.target.checked;

			// Enregistrer l'état dans le localStorage
			localStorage.setItem("gridVisible", isChecked);

			if (isChecked) {
				makeGrid();
			} else {
				let grid = document.getElementById("grid-debug");
				if (grid) {
					grid.remove();
				}
			}
		});
	};

	return {
		init: init,
	};
})();
